/* global google, propel, gtag */

import { __ } from '@wordpress/i18n';
import getCurrentLocation from 'propel/getCurrentLocation';
import setCurrentLocation from 'propel/setCurrentLocation';
import findClosestLocation from 'propel/findClosestLocation';

const inputs = document.querySelectorAll('.block-location-search-field__input');

const submitForm = (form) => {
	const submitEvent = new CustomEvent('location-search-field-form-submitted');

	if ('function' === typeof gtag) {
		gtag('event', 'Location Search', {
			event_category: 'Location Finder',
		});
	}

	window.dispatchEvent(submitEvent);

	if (!form.closest('.block-filter-locations')) {
		form.submit();
	}
};

const updateUrl = (form) => {
	const action = form.getAttribute('action');
	const actionURL = new URL(action, window.location.origin);

	if (form.dataset.search) {
		actionURL.searchParams.set('l', form.dataset.search);
	} else {
		actionURL.searchParams.delete('l');
	}

	form.setAttribute('action', actionURL.toString());
};

const initializeUserLocationButtons = () => {
	const userLocationButtons = document.querySelectorAll(
		'.block-location-search-field__user-location-button:not(.initalized), .block-filter-locations__search-nearby-button:not(.initalized)'
	);

	userLocationButtons.forEach((button) => {
		button.classList.add('initalized');

		button.addEventListener('click', (e) => {
			const currentButton = e.currentTarget;
			let block, messageElement, form, latInput, lngInput, searchInput;

			if (
				currentButton.classList.contains(
					'block-filter-locations__search-nearby-button'
				)
			) {
				const parentBlock = currentButton.closest(
					'.block-filter-locations'
				);
				block = parentBlock.querySelector(
					'.block-location-search-field'
				);
				messageElement = block.querySelector(
					'.block-location-search-field__user-location-message'
				);
				form = parentBlock.querySelector(
					'.block-location-search-field__form'
				);
				latInput = form.querySelector(
					'.block-location-search-field__lat-input'
				);
				lngInput = form.querySelector(
					'.block-location-search-field__lng-input'
				);
				searchInput = form.querySelector(
					'.block-location-search-field__input'
				);
			} else {
				block = currentButton.closest('.block-location-search-field');
				messageElement = block.querySelector(
					'.block-location-search-field__user-location-message'
				);
				form = button.closest('.block-location-search-field__form');
				latInput = form.querySelector(
					'.block-location-search-field__lat-input'
				);
				lngInput = form.querySelector(
					'.block-location-search-field__lng-input'
				);
				searchInput = form.querySelector(
					'.block-location-search-field__input'
				);
			}

			currentButton.classList.add('loading');

			if (!navigator.geolocation) {
				if (messageElement) {
					messageElement.innerText = __(
						'Geolocation is not supported by your browser. Try searching for a zip code or city instead.',
						'propel'
					);
				}

				currentButton.classList.remove('loading');

				return;
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					const lat = position.coords.latitude;
					const lng = position.coords.longitude;

					if (latInput) {
						latInput.value = lat;
					}
					if (lngInput) {
						lngInput.value = lng;
					}

					if (messageElement) {
						messageElement.innerText = '';
					}

					form.setAttribute('data-search', '');

					if (!currentLocation || !currentLocation.locationId) {
						findClosestLocation().then((foundLocation) => {
							if (
								foundLocation?.locationId &&
								foundLocation?.yextId &&
								foundLocation?.locationName
							) {
								setCurrentLocation(
									foundLocation.locationId,
									foundLocation.yextId,
									foundLocation.locationName
								);
								searchInput.value = '';
								updateUserLocationElements(foundLocation);
								updateUrl(form);
								submitForm(form);

								if (form.closest('.block-filter-locations')) {
									currentButton.classList.remove('loading');
								}
							} else {
								searchInput.value = __('My Location', 'propel');
								updateUrl(form);
								submitForm(form);

								if (form.closest('.block-filter-locations')) {
									currentButton.classList.remove('loading');
								}
							}
						});
					} else {
						searchInput.value = __('My Location', 'propel');
						updateUrl(form);
						submitForm(form);

						if (form.closest('.block-filter-locations')) {
							currentButton.classList.remove('loading');
						}
					}
				},
				(error) => {
					let errorMsg = '';

					if (error.code === error.PERMISSION_DENIED) {
						errorMsg = __(
							'Please allow location access in your browser settings or search by zip code or city.',
							'propel'
						);
					} else {
						errorMsg = __(
							'Unable to find location. Try searching by zip code or city.',
							'propel'
						);

						if (
							propel?.siteUrl?.includes('localhost') ||
							propel.siteUrl.includes('.829') ||
							propel?.siteUrl?.includes('.local')
						) {
							console.log(error); // eslint-disable-line no-console
						}
					}

					if (messageElement) {
						messageElement.innerText = errorMsg;
					}

					currentButton.classList.remove('loading');
				},
				{
					enableHighAccuracy: true,
					timeout: 1000,
					maximumAge: 0,
				}
			);
		});
	});
};

initializeUserLocationButtons();

if (document.querySelector('.block-filter-locations')) {
	window.addEventListener('propel-filters-render-posts', () => {
		initializeUserLocationButtons();
	});

	window.addEventListener('filter-locations-user-location-changed', (e) => {
		if (!e.detail) {
			return;
		}

		const { block } = e.detail;

		if (!block) {
			return;
		}

		const form = block.querySelector('.block-location-search-field__form');

		if (!form) {
			return;
		}

		updateUrl(form);
		submitForm(form);
	});
}

const updateUserLocationElements = (locationInfo) => {
	if (
		!locationInfo ||
		!locationInfo.locationId ||
		!locationInfo.locationName
	) {
		const userLocationLinks = document.querySelectorAll(
			'.block-location-search-field__user-location a'
		);

		userLocationLinks.forEach((link) => {
			if (!link?.classList?.contains('gfield-fsa-location-link')) {
				link.remove();
			}

			link?.parentElement?.classList.remove(
				'block-location-search-field__user-location--set'
			);
		});

		return;
	}

	const userLocationElements = document.querySelectorAll(
		'.block-location-search-field__user-location'
	);

	userLocationElements.forEach((element) => {
		const link = document.createElement('a');
		link.href = propel.siteUrl + '?p=' + locationInfo.locationId;
		link.innerText =
			__('My Store:', 'propel') + ' ' + locationInfo.locationName;
		element.innerHTML = '';
		element.appendChild(link);
		element.classList.add(
			'block-location-search-field__user-location--set'
		);

		if (
			element.nextElementSibling &&
			'INPUT' === element.nextElementSibling.tagName
		) {
			const form = element.closest('form');
			const locationIdInput = form.querySelector(
				'input[name="input_1000000"]'
			);
			locationIdInput.value = locationInfo.locationId;
		}
	});
};

const currentLocation = getCurrentLocation();

if (currentLocation) {
	updateUserLocationElements(currentLocation);
}

window.addEventListener('propel-current-location-set', (e) => {
	if (!e.detail) {
		return;
	}

	const { locationId, yextId, locationName } = e.detail;

	updateUserLocationElements({
		locationId: locationId ?? '',
		yextId: yextId ?? '',
		locationName: locationName ?? '',
	});
});

window.addEventListener('propel-update-location-search-fields', () => {
	const newLocation = getCurrentLocation();

	if (newLocation) {
		updateUserLocationElements(newLocation);
	} else {
		updateUserLocationElements({
			locationId: '',
			yextId: '',
			locationName: '',
		});
	}
});

async function initLocationSearchField() {
	const { AutocompleteSuggestion, AutocompleteSessionToken } =
		await google.maps.importLibrary('places');

	const sessionToken = new AutocompleteSessionToken();

	inputs.forEach((input) => {
		const form = input.closest('form');
		const latInput = form.querySelector(
			'.block-location-search-field__lat-input'
		);
		const lngInput = form.querySelector(
			'.block-location-search-field__lng-input'
		);

		const dropdown = document.createElement('ul');
		dropdown.classList.add('block-location-search-field__dropdown');
		dropdown.setAttribute('role', 'listbox');
		input.parentElement.style.position = 'relative';
		input.parentElement.appendChild(dropdown);

		input.addEventListener('focus', () => {
			const rect = input.getBoundingClientRect();
			const bottomDistance = window.innerHeight - rect.bottom;

			if (bottomDistance < 200) {
				input.scrollIntoView({
					scrollMode: 'if-needed',
					behavior: 'auto',
					block: 'start',
					inline: 'start',
				});
			}
		});

		input.addEventListener('input', async () => {
			const value = input.value.trim();

			if (!value) {
				dropdown.classList.remove(
					'block-location-search-field__dropdown--active'
				);
				dropdown.innerHTML = '';
				return;
			}

			const { suggestions } =
				await AutocompleteSuggestion.fetchAutocompleteSuggestions({
					input: value,
					sessionToken,
					includedRegionCodes: ['us'],
					includedPrimaryTypes: [
						'locality',
						'postal_code',
						'street_address',
					],
				});

			dropdown.innerHTML = '';

			if (!suggestions || !suggestions.length) {
				dropdown.classList.remove(
					'block-location-search-field__dropdown--active'
				);
				return;
			}

			suggestions.forEach((prediction) => {
				const li = document.createElement('li');

				const button = document.createElement('button');
				button.type = 'button';
				button.classList.add(
					'block-location-search-field__dropdown-item'
				);
				button.setAttribute('role', 'option');
				button.setAttribute(
					'aria-label',
					[
						prediction.placePrediction.mainText.text,
						prediction.placePrediction.secondaryText.text,
					].join(', ')
				);

				button.textContent = [
					prediction.placePrediction.mainText.text,
					prediction.placePrediction.secondaryText.text,
				].join(', ');

				button.addEventListener('click', async () => {
					input.value = button.textContent;
					form.setAttribute('data-search', input.value);

					const place = prediction.placePrediction.toPlace();
					await place.fetchFields({ fields: ['location'] });

					if (place.location) {
						latInput.value = place.location.lat();
						lngInput.value = place.location.lng();
					}

					submitForm(form);
					dropdown.classList.remove(
						'block-location-search-field__dropdown--active'
					);
					dropdown.innerHTML = '';
				});

				li.appendChild(button);
				dropdown.appendChild(li);
			});

			dropdown.classList.add(
				'block-location-search-field__dropdown--active'
			);
		});

		form.addEventListener('keydown', (e) => {
			const items = dropdown.querySelectorAll('button');

			if (!items || !items.length) {
				if ('Enter' === 'e.key') {
					form.setAttribute('data-search', input.value);
					updateUrl(form);
					submitForm(form);
				}

				return;
			}

			const current = Array.from(items).indexOf(
				dropdown.ownerDocument.activeElement
			);

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				const next = (current + 1) % items.length;
				items[next].focus();
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				const prev = (current - 1 + items.length) % items.length;
				items[prev].focus();
			} else if (e.key === 'Enter') {
				e.preventDefault();

				if (current >= 0) {
					items[current].click();
				} else {
					items[0].click();
				}
			} else if (e.key === 'Escape') {
				dropdown.classList.remove(
					'block-location-search-field__dropdown--active'
				);
				dropdown.innerHTML = '';
				input.focus();
			}
		});

		document.addEventListener('click', (e) => {
			if (!form.contains(e.target)) {
				dropdown.classList.remove(
					'block-location-search-field__dropdown--active'
				);
				dropdown.innerHTML = '';
			}
		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();

			if (__('My Location', 'propel') !== input.value) {
				form.setAttribute('data-search', input.value);
				form.querySelector(
					'.block-location-search-field__lat-input'
				).value = '';
				form.querySelector(
					'.block-location-search-field__lng-input'
				).value = '';
			}

			updateUrl(form);
			submitForm(form);
		});
	});
}

if (window?.google?.maps) {
	initLocationSearchField();
} else {
	window.addEventListener('google-maps-loaded', initLocationSearchField);
}
